import { React, Table } from '@1337lawyers/design';

export const TrackingVerificationRequests = () => (
  <Table headers={['Issuer', 'Investor', 'Requested', 'Status']} data={[]} />
);
